import { Spinner } from '../../atoms/Spinner';
import { cn } from '../../lib/utils';

export interface WidgetLoadingStateProps {
  className?: string;
}

export function WidgetLoadingState({ className }: WidgetLoadingStateProps) {
  return (
    <div className={cn('flex items-center justify-center py-6', className)}>
      <Spinner animate />
      <span className="sr-only">Loading…</span>
    </div>
  );
}

WidgetLoadingState.displayName = 'WidgetLoadingState';
